(function (Drupal) {
  Drupal.behaviors.tabsmediaslider = {
    attach() {
      const dir = $('html').attr('dir');
      const dirVal = dir === 'rtl' ? 'rtl' : 'ltr';

      const containers = document.querySelectorAll(
        '.drl-russia-tabs-with-text-and-media'
      );

      containers.forEach((container) => {
        const mainSelector = container.querySelector(
          '.main-slider .carousel-main-slider'
        );
        const thumbSelector = container.querySelector(
          '.thumbnail-slider .carousel-thumbnail-slider'
        );

        // Make sure both exist before initializing
        if (mainSelector && thumbSelector) {
          const main = new Splide(mainSelector, {
            type: 'loop',
            rewind: true,
            direction: dirVal,
            pagination: false,
            arrows: false,
            autoplay: false,
            perPage: 1,
            perMove: 1,
          });

          const thumbs = new Splide(thumbSelector, {
            direction: dirVal,
            type: 'loop',
            rewind: true,
            perPage: 4,
            perMove: 1,
            pagination: false,
            arrows: true,
            autoplay: false,
            gap: 30,
            breakpoints: {
              1023: {
                gap: 10,
                arrows: false,
                perPage: 1,
              },
            },
          });

          main.sync(thumbs);
          thumbs.mount();
          main.mount();
        }
      });
    },
  };
})(Drupal);
